export {AuthenticationAngularService as AuthenticationService} from './lib/authentication';
